import Carousal1Desktop from "assets/carousals/carousal_1_desktop.jpg";
import Carousal1Mobile from "assets/carousals/carousal_1_mobile.jpg";
import Carousal2Desktop from "assets/carousals/carousal_2_desktop.jpg";
import Carousal2Mobile from "assets/carousals/carousal_2_mobile.jpg";
import Carousal3Desktop from "assets/carousals/carousal_3_desktop.jpg";
import Carousal3Mobile from "assets/carousals/carousal_3_mobile.jpg";
import Carousal4Desktop from "assets/carousals/carousal_4_desktop.jpg";
import Carousal4Mobile from "assets/carousals/carousal_4_mobile.JPG";

export const CarousalItemOption = [
  {
    desktop_src: Carousal1Desktop,
    mobile_src: Carousal1Mobile,
  },
  {
    desktop_src: Carousal2Desktop,
    mobile_src: Carousal2Mobile,
  },
  {
    desktop_src: Carousal4Desktop,
    mobile_src: Carousal4Mobile,
  },
  {
    desktop_src: Carousal3Desktop,
    mobile_src: Carousal3Mobile,
  },
];
